import Http from '@/utils/http'
import { RequestType } from '@/typings/enum/Common'
import NGroupContributionApi = global.NGroupContributionApi

class BankcardVag extends Http {
  [x: string]: any

  /**
   * 群组贡献（区分角色）
   * @param data
   */
  public async getGroupContributionWithRole(data: NGroupContributionApi.GroupContributionRequest) {
    return await super.request<NGroupContributionApi.GroupContributionResponse>({
      url: '/crossbowSystem/getCDStaticInfo',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/json'
      },
      data
    })
  }

  /**
   * 群组贡献（不区分角色）
   * @param data
   */
  public async getGroupContributionWithoutRole(data: NGroupContributionApi.GroupContributionRequest) {
    return await super.request<NGroupContributionApi.GroupContributionResponse>({
      url: '/crossbowSystem/getComprehensiveCDStaticInfo',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/json'
      },
      data
    })
  }
}

export default BankcardVag
